import React from 'react';
import { F, C, STATUS_STYLE } from '../../config/styles';

export function StatusBadge({ status }) {
  const s = STATUS_STYLE[status] || STATUS_STYLE.empty;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      fontSize: 11, fontWeight: 500, fontFamily: F.body,
      color: s.fg, background: s.bg, border: `1px solid ${s.border}`,
      borderRadius: 20, padding: '2px 8px', whiteSpace: 'nowrap',
    }}>
      {s.label}
    </span>
  );
}

export function Ring({ pct, size = 44, stroke = 4 }) {
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const dash = (pct / 100) * circ;
  const color = pct === 100 ? '#6ee7b7' : C.text;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ flexShrink: 0 }}>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={C.e8} strokeWidth={stroke} />
      <circle
        cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
        strokeDasharray={`${dash} ${circ}`} strokeLinecap="round"
        style={{ transformOrigin: 'center', transform: 'rotate(-90deg)' }}
      />
      <text
        x="50%" y="50%" textAnchor="middle" dominantBaseline="central"
        style={{ fontSize: size * 0.25, fontFamily: F.body, fontWeight: 600, fill: C.text }}
      >
        {pct}%
      </text>
    </svg>
  );
}
